import $ from 'jquery'


window.$ = $
window.jQuery = $



// WEBPACK FOOTER //
// ./src/js/vendor.js